// Simple loader overlay utility
export function showLoader(): void {
  let loader = document.getElementById('global-loader');
  if (!loader) {
    loader = document.createElement('div');
    loader.id = 'global-loader';
    loader.style.position = 'fixed';
    loader.style.top = '0';
    loader.style.left = '0';
    loader.style.width = '100vw';
    loader.style.height = '100vh';
    loader.style.background = 'rgba(255,255,255,0.6)';
    loader.style.display = 'flex';
    loader.style.alignItems = 'center';
    loader.style.justifyContent = 'center';
    loader.style.zIndex = '9999';
    loader.innerHTML = '<div style="padding: 2rem; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); font-size: 1.5rem; color: #333;">Loading...</div>';
    document.body.appendChild(loader);
  } else {
    loader.style.display = 'flex';
  }
}

export function hideLoader(): void {
  const loader = document.getElementById('global-loader');
  if (loader) loader.style.display = 'none';
} 